import React, { useState } from 'react';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import Button from '@mui/material/Button';
import "react-datepicker/dist/react-datepicker.css";

/* ─── Same CSS as AssetInfo (Bulk Allocation) ─── */
import '../../ExcelUploads/AssetInfo/AssetInfo';

function UploadAuthorization() {
    const [dinno, setDinno] = useState('');
    const [searchDin, setSearchDin] = useState('');
    const [dinDate, setDinDate] = useState(null);

    return (
        <div className="asset-info-container">

            {/* ════════════════════════════
                PAGE HEADER
                ════════════════════════════ */}
            <div className="page-header">
                <div className="header-content">
                    <div className="header-left">
                        <div className="header-icon">
                            <i className="bi bi-shield-check" style={{ fontSize: '1.6rem' }} />
                        </div>
                        <div>
                            <h1 className="page-title">Upload Authorization</h1>
                            <p className="page-subtitle">Upload authorization details and documentation by DIN No</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ════════════════════════════
                SEARCH CARD
                ════════════════════════════ */}
            <div className="upload-cards-grid mb-4">
                <div className="upload-card parent-card" id="search-din-card" style={{ maxWidth: '100%' }}>
                    <div className="card-header">
                        <div className="card-icon parent-icon">
                            <i className="bi bi-search" style={{ fontSize: '1.4rem' }} />
                        </div>
                        <div className="card-header-text">
                            <h4>Search DIN Number</h4>
                            <p>Search existing authorization record by DIN number</p>
                        </div>
                    </div>
                    <div className="card-body">
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', maxWidth: '600px' }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search DIN No"
                                value={searchDin}
                                onChange={(e) => setSearchDin(e.target.value)}
                                style={{ borderRadius: '8px', padding: '10px 14px' }}
                            />
                            <Button variant="contained" className="upload-button" style={{ minWidth: '120px', whiteSpace: 'nowrap' }}>
                                <i className="bi bi-search" style={{ marginRight: 6 }} /> Search
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ════════════════════════════
                AUTHORIZATION UPLOAD FORM CARD
                ════════════════════════════ */}
            <div className="upload-cards-grid">
                <div className="upload-card parent-card" id="authorization-form-card" style={{ maxWidth: '100%' }}>
                    <div className="card-header">
                        <div className="card-icon parent-icon">
                            <i className="bi bi-file-earmark-arrow-up" style={{ fontSize: '1.4rem' }} />
                        </div>
                        <div className="card-header-text">
                            <h4>Authorization Details & File Upload</h4>
                            <p>Enter DIN details and upload the authorization document</p>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <FromFieldText
                                    label="DIN No"
                                    placeholder="Enter DIN No"
                                    inputValue={dinno}
                                    setInputValue={setDinno}
                                />
                            </div>
                            <div className="col-md-6">
                                <FromFieldDate
                                    label="Date of DIN"
                                    inputValue={dinDate}
                                    setInputValue={setDinDate}
                                />
                            </div>
                        </div>

                        <div className="mt-4" style={{ background: '#f8fafc', padding: '20px', borderRadius: '10px', border: '1px dashed #cbd5e1' }}>
                            <label style={{ fontWeight: 600, color: '#334155', display: 'block', marginBottom: '8px' }}>
                                <i className="bi bi-paperclip" style={{ marginRight: 6 }} />
                                Upload Authorization Document
                            </label>
                            <input type="file" name="asset_invoice" className="form-control" style={{ maxWidth: '500px' }} />
                        </div>

                        <div className="mt-4 text-center">
                            <Button variant="contained" className="upload-button" style={{ padding: '10px 36px', fontSize: '0.95rem' }}>
                                <i className="bi bi-check-circle" style={{ marginRight: 8 }} /> Submit Authorization
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default UploadAuthorization;